/**
 * @typedef {{
 *   job_id?: unknown,
 *   job_status?: unknown,
 *   version?: unknown,
 *   rendered_version?: unknown,
 * }} ReportJobStart
 */

/** @param {ReportJobStart | null | undefined} data */
export const reportJobId = (data) =>
  typeof data?.job_id === "string" && data.job_id ? data.job_id : null;

/**
 * Prefer the server-vetted failure text and make every terminal message
 * actionable. Worker exception details never cross this boundary.
 * @param {{message?: unknown} | null | undefined} failure
 * @param {string} fallback
 */
export const jobFailureMessage = (failure, fallback) => {
  const serverMessage = typeof failure?.message === "string" ? failure.message.trim() : "";
  const message = serverMessage || fallback;
  return /\b(?:try|retry)\b/i.test(message) ? message : `${message} Please try again.`;
};

/**
 * Queue dispatch can fail after an edit endpoint has committed the supplied
 * content. Return only that explicit, versioned recovery contract.
 * @param {unknown} error
 * @returns {(ReportJobStart & {content_saved: true, error?: unknown}) | null}
 */
export const savedWriteResponse = (error) => {
  const response = /** @type {{status?: unknown, data?: any} | undefined} */ (
    /** @type {{response?: unknown}} */ (error)?.response
  );
  const data = response?.data;
  if (
    response?.status !== 503 ||
    data?.content_saved !== true ||
    !Number.isSafeInteger(data.version) ||
    data.version < 1
  ) {
    return null;
  }
  return data;
};

/** @param {unknown} value */
export const reportVersion = (value) =>
  Number.isSafeInteger(value) && /** @type {number} */ (value) > 0
    ? /** @type {number} */ (value)
    : null;
